module.exports = __webpack_public_path__ + "assets/img/email.da1273e7.png";